/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import axios, { AxiosInstance } from "axios";
import { IAssetData, IGasPrices, IParsedTx } from "./types/walletapi.types";
import {StorageModule} from "@vlinder-web/storage-module-react";
// import {GET_WALLET_BALANCE}  from "../pages/WalletScreen/graphql/get-wallet-balance.query";
import { toast } from "react-hot-toast";
import { humanize } from "uno-js";
import {getErrorMessage} from "../utils/error.message";

const is = require("is_js");

const MODULE_NAME = "MyWalletService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

const api: AxiosInstance = axios.create({
    baseURL: "https://ethereum-api.xyz",
    timeout: 30000, // 30 secs
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
    },
});

export class WalletApiService {
    private static instance: WalletApiService;

    private constructor(props: any = {}) {}
    public static getInstance(props: any = {}): WalletApiService {
        if (!WalletApiService.instance) {
            WalletApiService.instance = new WalletApiService(props);
        }
        return WalletApiService.instance;
    }

    async getAccountAssets(
        address: string,
        chainId: number
    ): Promise<IAssetData[]> {
        const response = await api.get(
            `/account-assets?address=${address}&chainId=${chainId}`
        );
        const { result } = response.data;
        return result;
    }

    async getAccountTransactions(
        address: string,
        chainId: number
    ): Promise<IParsedTx[]> {
        const response = await api.get(
            `/account-transactions?address=${address}&chainId=${chainId}`
        );
        const { result } = response.data;
        return result;
    }

    async getAccountNonce(address: string, chainId: number): Promise<string> {
        const response = await api.get(
            `/account-nonce?address=${address}&chainId=${chainId}`
        );
        const { result } = response.data;
        return result;
    }

    async getGasPrice() {
        const response = await api.get(`/gas-prices`);
        const { result } = response.data;
        return result;
    }

    async getAccountBalance(address: string, chainId: number) {
        const response = await api.get(
            `/account-balance?address=${address}&chainId=${chainId}`
        );
        const { result } = response.data;
        return result;
    }

    // async getWalletBalance() {
    //     const graphqlModule = getGraphQLModule();
    //     const client = graphqlModule.getClient("graphql-gateway");
    //     const storageService = StorageModule.getInstance();
    //     const did = storageService.get("userProfile", "session")?.value?.brand?.walletAddress;
    //     console.log('did in getWallet', did);
    //     try {
    //         if (client) {
    //             // const res = await client.query({
    //             //     query: GET_WALLET_BALANCE,
    //             //     variable:{did:did},
    //             //     fetchPolicy:'network-only'
    //             // });
    //             // log.success(`getMyBalance`, res);
    //             // if(res?.data){
    //             //     return res?.data?.getMyBalance;
    //             // }
               
    //         }
    //         // return true;
    //     } catch (err: any) {
    //         getErrorMessage(err);
    //     }
    // }
}
